import {TabContainer} from "base/ui/tab/components";
import {ViewTreesSection} from "tree/container";
import {ViewMaterialsSection} from "material/container";
import {PermitApplicationTypesContent} from ".";
import {PermitForm} from "./form";

const PermitApplicationTechnicalDataTabs = ({
    permit,
    isStepEditable,
    onSubmitPermitApplication,
}) => {
    const tabs = [
        {
            label: "Guias",
            hash: "types",
            content: (
                <PermitForm permit={permit} onSubmit={onSubmitPermitApplication}>
                    <PermitApplicationTypesContent
                        permit={permit}
                        isStepEditable={isStepEditable}
                    />
                </PermitForm>
            ),
            disabled: false,
        },
        {
            label: "Árvores",
            hash: "trees",
            content: (
                <ViewTreesSection
                    permit={permit}
                    displayFees={false}
                    disabled={!isStepEditable}
                />
            ),
            disabled:
                !permit?.types?.includes("felling") &&
                !permit?.types?.includes("cutting"),
        },
        {
            label: "Materiais",
            hash: "materials",
            content: (
                <ViewMaterialsSection
                    permit={permit}
                    displayFees={false}
                    disabled={!isStepEditable}
                />
            ),
            disabled: !permit?.types?.includes("transport"),
        },
    ];

    return <TabContainer tabs={tabs} />;
};

export default PermitApplicationTechnicalDataTabs;
